import { API_ENDPOINTS } from "../../../../config/api/apiCall";


const calculateNoOfSheets = async (formState, setAlertMessage, setAlertSeverity, showSnackbar) => {
  let noOfSheets = formState.NOOFSHEETS;
  let noOfSheetsOld = formState.NOOFSHEETS;
  //let reemWeight = 0;

  try {


    const response = await fetch(API_ENDPOINTS.GET_DEFAULT_REAM_WEIGHT_DETAILS, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify()
    });

    if (!response.ok) {
      throw new Error('Unable to calculate the no of sheets properly..!');
    }

    const data = await response.json();

    // new function started
    let localPackageMode = '';
    if (!localPackageMode) localPackageMode = "Ream";
    if (formState.GSM === 0) localPackageMode = "ZeroGSM";
    let size_unit = formState.UNITTYPE;

    const allowToExceed = data.MaxWeightOfBundleInKg;
    let itemWidth = 0;
    let itemLength = 0;

    // Convert units → cm
    if (size_unit) {
      if (size_unit.toLowerCase() === "mm") {
        itemWidth = formState.WIDTH / 10;
        itemLength = formState.LENGTH / 10;
      } else if (
        size_unit.toLowerCase() === "inch" ||
        size_unit.toLowerCase() === "inches"
      ) {
        itemWidth = formState.WIDTH * 2.54;
        itemLength = formState.LENGTH * 2.54;
      }
    }

    if (noOfSheets > data.MaxNoOfSheetsPerReam || noOfSheets == 0) {
      noOfSheets = data.MaxNoOfSheetsPerReam;
    }

    let reamWeight = parseFloat(
      ((itemWidth / 100) * (itemLength / 100) * formState.GSM * (noOfSheets / 1000)).toFixed(1)
    );

    if (noOfSheets === 0) {
      reamWeight = data.MaxWeightOfReamInKg;
    }

    if (reamWeight > data.MaxWeightOfReamInKg) {
      noOfSheets = data.MaxNoOfSheetsPerReam;

      while (reamWeight > data.MaxWeightOfReamInKg) {
        noOfSheets = Math.floor(noOfSheets / 2);
        if (noOfSheets === 125) {
          noOfSheets = 144;
        }
        reamWeight = parseFloat(
          ((itemWidth / 100) * (itemLength / 100) * formState.GSM * (noOfSheets / 1000)).toFixed(1)
        );
      }
    }  

    if (formState.LENGTH > 0 && noOfSheets != noOfSheetsOld) {
      formState.NOOFSHEETS = noOfSheets;
    }

    formState.ReamWeight = reamWeight;

    return reamWeight; // You can return whatever value you need
  } catch (error) {
    setAlertMessage('Unable to calculate the no of sheets properly..!');
    setAlertSeverity('error');
    showSnackbar();
    return null; // Or any other default/fallback value
  }
};

export default calculateNoOfSheets;
